import { Component, OnInit, Input } from '@angular/core';

import { ToolAdapterService } from '../../tools/tool-adapter.service';
import { DesignerConfigurationService } from '../../services/designer-configuration.service';
import { DrawToolService } from '../../tools/draw-tool.service';

import { ControlSpecification } from '../../types/specification.types';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-tool-box-control',
  templateUrl: './tool-box-control.component.html',
  styleUrls: ['./tool-box-control.component.css']
})
export class ToolBoxControlComponent implements OnInit {
  _specification: ControlSpecification;

  @Input()
  get specification(): ControlSpecification {
    return this._specification;
  }
  set specification(value: ControlSpecification) {
    this._specification = value;
  }

  get isActive(): boolean {
    const tool = <DrawToolService>this.toolAdapter.currentTool;
    return tool && tool.specification && tool.specification === this._specification;
  }

  constructor(
    private toolAdapter: ToolAdapterService,
    private designerConfigurationService: DesignerConfigurationService
  ) {}

  ngOnInit() {}

  select() {
    this.toolAdapter.startDraw(this.specification);
    // this.designerConfigurationService.selectState.next(false);
  }
}
